<!-- Выбор связанных ремонтов или пометок текущего ТС -->
<template>
  <RecordListRelatedSelect :model-value="modelValue" :vehicle-id="vehicleId" :initial-records="initialRecords"
    :disabled="disabled" :fetch-records="fetchRecords" :record-label="recordLabel"
    :placeholder="resource === 'repairs' ? 'Добавить ремонт' : 'Добавить пометку'"
    @update:model-value="$emit('update:modelValue', $event)">
    <template #record="{ record, remove }">
      <FleetRepairRemarkCard :record="record" :resource="resource" :vehicle-id="vehicleId"
        removable :disabled="disabled" @remove="remove" />
    </template>
  </RecordListRelatedSelect>
</template>
<script>
import RecordListRelatedSelect from "@/components/RecordList/RelatedSelect.vue";
import FleetRepairRemarkCard from "@/components/Fleet/RepairRemark/Card.vue";
import { useRepairRemarkLinkStore } from "@/stores/repairRemarkLinkStore";
export default {
  name: "FleetRepairRemarkSelect",
  components: { RecordListRelatedSelect, FleetRepairRemarkCard },
  props: {
    resource: { type: String, required: true },
    vehicleId: { type: [Number, String], default: null },
    modelValue: { type: Array, default: undefined },
    initialRecords: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  methods: {
    fetchRecords(vehicleId, search) {
      return useRepairRemarkLinkStore().fetchRecords(this.resource, vehicleId, search);
    },
    recordLabel(record) {
      const name = this.resource === "repairs" ? record.title : record.name || record.text;
      return ["№" + record.id, name, record.archived_at ? "В архиве" : null].filter(Boolean).join(" · ");
    },
  },
};
</script>
